import React, {  useContext } from "react";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { useStyles } from "../../assets/styles/CustomStyles";
import StepperRemision from "../../components/remision/editar/StepperRemision";

import RemisionProvider from "../../utils/remisionContext/RemisionProvider";
import AccesoDenegado from "../../components/AccesoDenegado";
import UserContext from "../../utils/user/UserContext";

export default function EditarRemision() {

    const classes = useStyles();
    const userContext = useContext(UserContext);

    return (
        <>
            {Number(userContext.state.accesos.remision) === 1 ?

                <RemisionProvider>
                    <Grid container direction="row" justify="center" alignItems="center" >
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <Card className={classes.root}>
                                <CardContent>
                                    <Typography variant="body1" display="block">
                                        EDITAR NOTA DE REMISION
                                    </Typography>
                                    <StepperRemision />
                                </CardContent>
                            </Card>
                        </Grid>
                    </Grid>
                </RemisionProvider>
                : <AccesoDenegado />}

        </>
    );
}
